<template>
    <div>
        <modal class="resend-verified" :display="modalStatus.resendEmailVerified" @modalStatus="closeModal" >
            <alarm-msg-white type="SUCCESS" :msg="alarm.success.msg" :count="alarm.success.count" :showAlarm="alarm.success.status" @timeOut="alarm.success.status=false"></alarm-msg-white>
            <alarm-msg-white type="ERROR" :msg="alarm.error.msg" :count="alarm.error.count" :showAlarm="alarm.error.status" @timeOut="alarm.error.status=false"></alarm-msg-white>
            <!-- <alarm-msg-white type="ERROR" msg="此電子郵件無人使用" :count="2000" :showAlarm="isShowAlarm" @timeOut="isShowAlarm=false"></alarm-msg-white> -->
            <h1>重新寄送認證信</h1>
            <div class="resend-verified-wrap">
                <div class="description">
                    輸入註冊使用的信箱，系統將會重發送一封認證信！
                </div>
                <div class="account">
                    <label for="account" class="button-font input-label">
                        <span></span>
                        <span v-show="error.resend.account" class="error-with-title">{{error.resend.account}}</span>
                    </label>
                    <div class="input-error-group">
                        <input :class="{error: error.resend.account}" type="text" v-model="resend.account" placeholder="請輸入電子郵件帳號">
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <div class="loading-wrap">
                    <btn-loading v-if="status.isDisable"></btn-loading>
                    <button class="default-button confirm" :disabled="status.isDisable" @click="resendVerified()">
                        重新寄送驗證信
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import alarmMsgWhite from '@/components/bussiness/widges/alarms/alarmMsgWhite.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import { mapGetters } from 'vuex'
import { apiBizResendVerified } from "@/apis/api.js"; 

export default {
    data () {
        return {
            resend: {
                account: null
            },
            error: {
                resend: {
                    account: null
                }
            },
            alarm: {
                success:{
                    status: false,
                    msg: null,
                    count: 2000
                },
                error:{
                    status: false,
                    msg: null,
                    count: 2000
                }
            },
            status: {
                isDisable: false,
            }
        }
    },
    watch: {
        'resend.account': function (val) {
            console.log(val)
            let isMail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
            
            if( val.length > 0 ){
                if (!isMail.test(val)) {
                    this.error.resend.account = '電子郵件格式錯誤';
                }else {
                    this.error.resend.account = null;
                }
            }else{
                this.error.resend.account = null;
            }
        }
    },
    methods: {
        resendVerified: function () {
            if(this.checkInput()){
                let account = this.resend.account
                let data = {account}

                this.status.isDisable = true 

                apiBizResendVerified(data)
                .then(res => {
                    console.log(res)
                    this.status.isDisable = false 
                    if( res.data.status == "SUCCESS" ){
                        this.alarm.success.msg = '密碼重置函已寄出，請前往信箱收信，並完成後續動作'
                        this.alarm.success.status = true
                    }else{
                        this.alarm.error.msg = res.data.errorMsg
                        this.alarm.error.status = true
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.status.isDisable = false 
                    this.alarm.error.msg = '系統發生未預期錯誤，請再試一次'
                    this.alarm.error.status = true
                })
            }
            
        },
        checkInput: function () {
            if(!this.resend.account){
                this.error.resend.account = '請輸入電子郵件'
            }
            if(
                this.resend.account &&
                this.error.resend.account == null
            ){
                return true
            }else{
                return false
            }
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'resendEmailVerified'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        alarmMsgWhite,
        btnLoading
    }
}
</script>
<style lang="scss"  >
    #modal.resend-verified{
        .modal-content{
            width: 368px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    text-align: center;
                    font-size: 24px;
                    margin: 32px auto 24px;
                    line-height: 1.5;
                }
                .resend-verified-wrap{
                    width: 308px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    margin: 0 auto;
                    .description{
                        width: 286px;
                        text-align: center;
                        line-height: 1.71;
                        margin-bottom: 3px;
                    }
                    .account{
                        width: 308px;
                        margin-bottom: 30px;
                        label{
                            height: 16px;
                        }
                        input{
                            width: 100%;
                            box-sizing: border-box;
                        }
                        
                    }
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 308px;
                        height: 44px;
                        margin-bottom: 0px;
                        
                    }
                    .loading-wrap{
                        position: relative;
                        .btn-loading{
                            left: 64px;
                            top: 6px;
                        }
                    }
                }
            }
      
        }
    }
    @media screen and (max-width: 375px) {
        #modal.resend-verified{
            .modal-content{
                width: 340px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/resendVerified.vue